import type { Widget } from "@app-contexts/sdk/services/Widget";
import { recordAppError } from "@shared/utils/errors/errorLogger";

export type EmbeddedWidgetTransition = (
  createWidget: () => Promise<Widget>
) => void;

export function createEmbeddedWidgetTransition(
  widget: Widget
): EmbeddedWidgetTransition {
  let embeddedTransition: Promise<void> | undefined;

  return (createWidget) => {
    if (embeddedTransition) return;

    embeddedTransition = createWidget()
      .then(() => {
        widget.dispose();
      })
      .catch((error) => {
        recordAppError(error);
      })
      .finally(() => {
        embeddedTransition = undefined;
      });
  };
}
